import * as Sentry from '@sentry/svelte';
const TARGETS = [/^https:\/\/api.smatch\.dev/u, /^https:\/\/api.smatch\.com/u];
const maskKeys = (data) => {
    const REGEX = /[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}/gu;
    return data.replace(REGEX, '$key');
};
const generateFingerprint = (status, verb, path) => `${status ?? '000'} ${verb} ${path}`
    .toLowerCase()
    .replace(/[/?=]/gu, '-');
const getStatus = (message) => {
    const STATUS = (/[0-9]{3}/u).exec(message);
    if (STATUS === null) {
        return '000';
    }
    return STATUS[0];
};
const formatHttpError = (event) => {
    if (event.message === undefined) {
        return event;
    }
    if (!event.message.startsWith('HTTP Client Error with status code')) {
        return event;
    }
    let { pathname, search } = new URL(event.request?.url ?? '');
    const STATUS = getStatus(event.message);
    const VERB = event.request?.method ?? 'NO METHOD';
    pathname = maskKeys(pathname);
    search = maskKeys(search);
    event.message = `API: ${STATUS} on ${VERB} ${pathname}${search}`;
    event.fingerprint = [generateFingerprint(STATUS, VERB, `${pathname}${search}`)];
    return event;
};
export const setContext = (scope, data) => {
    Sentry.setContext(scope, data);
};
export const setUserContext = (session) => {
    if (session === null) {
        return;
    }
    setContext('user', {
        isInternal: session.organization.domain === 'internal' ? 'Yes' : 'No',
        organizationKey: session.organization._.key,
        organizationName: session.organization.name,
        userKey: session.user._.key,
        userState: session.user._.state,
    });
};
// eslint-disable-next-line max-lines-per-function
export const init = (dsn, environment) => {
    if (environment === 'development') {
        return;
    }
    Sentry.init({
        beforeSend(event) {
            return formatHttpError(event);
        },
        dsn,
        environment,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
            Sentry.contextLinesIntegration(),
            Sentry.extraErrorDataIntegration(),
            Sentry.httpClientIntegration({ failedRequestStatusCodes: [[300, 599]] }),
        ],
        normalizeDepth: 5,
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        tracePropagationTargets: TARGETS,
        tracesSampleRate: 1.0,
    });
};
